// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"74b6437d","239":"23a4bd8f","455":"7cac19ab"}[chunkId] + ".chunk.js";
};